import * as React from "react";

const CalenderIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      stroke="#5D6B7F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12 1.834v1.333M4 1.834v1.333M1.667 8.662c0-2.905 0-4.357.834-5.26C3.336 2.5 4.68 2.5 7.367 2.5h1.266c2.687 0 4.03 0 4.865.902.835.903.835 2.355.835 5.26v.343c0 2.904 0 4.357-.835 5.26-.834.902-2.178.902-4.865.902H7.367c-2.687 0-4.031 0-4.866-.903-.834-.902-.834-2.355-.834-5.26zM2 5.834h12"
    ></path>
  </svg>
);

export default CalenderIcon;
